import React from 'react'
import CommonTeam from '../CommonComponent/CommonTeam'
export default function Team() {
  return (
    <>
    <div className="teamSpace"></div>
      <CommonTeam/>
      <div className="teamSpace"></div>
    </>
  )
}
